import { request as __request } from "../core/request";
import { VrpCreateConsentRequest } from "../models/VRP/VrpCreateConsentRequest";
import { VariableRecurringPaymentConsentResponse } from "../models/VRP/VariableRecurringPaymentConsentResponse";

export class VrpService {
    /**
     * @returns VrpConsentResponse
     * @throws ApiError
     */
    public static async GetVrpConsent({
        missionId,
        environment,
        consentRequest,
    }: {
        missionId: string;
        environment?: "Prod" | "Test" | "SquadExpansionProd" | "SandboxSquirrel" | "SandboxCapybara" | "SandboxMousedeer" | "SandboxPlatypus" | "SandboxSloth" | "Spiir" | "SpiirTest" | "ProdNe" | "ProdWe" | "SpiirNe" | "SpiirWe" | "SpiirAws";
        consentRequest: VrpCreateConsentRequest;
    }): Promise<VariableRecurringPaymentConsentResponse> {
        const result = await __request({
            method: "POST",
            path: "/api/vrp/create",
            query: {
                missionId: missionId,
                environment: environment,
            },
            body: consentRequest,
        });
        return result.body;
    }
}
